export default __webpack_public_path__ + "6d3b49a931f4410709deaefb87b8f9d0.jpg";